export default {
  /**
   * The value of the field
   * @model
   */
  value: {
    type: String,
    default: '',
  },

  /**
   * Does not transition the color nor the shadow of the field when this
   * prop is set to true.
   */
  alternativeFocus: Boolean,

  /**
   * Does not respond to esc keyup event
   */
  noEscListener: Boolean
}
